// deps
import React, { memo } from "react";

// internal-deps
import { ElementObserver, LottieAnimation, STYLE_SHEET_VAR } from "@swiggy-private/core-ui";
import { SAVINGS_STAMP_TEST_IDS } from "@swiggy-private/cart-test-ids";

// helpers
import { cloneDeep, isEmpty } from "@swiggy-private/js-utils";

// styles
import { useSavingsStamp } from "./hooks/useSavingsStamp";
import { SavingsStampLottieContainer } from "./SavingsStamp.style";

export interface ISavingsStamp {
    xpEnabled: boolean;
    title: string;
    subtitle: string;
    isBillCollapsible: boolean;
    isBillUncollapsed: boolean;
    onImpressionSavingsStamp: (context: Record<string, unknown>) => void;
}

function SavingsStamp({
    xpEnabled,
    title,
    subtitle,
    isBillCollapsible,
    isBillUncollapsed,
    onImpressionSavingsStamp,
}: ISavingsStamp) {
    const { showLottie, lottieData, onBillEnter } = useSavingsStamp({
        xpEnabled,
        title,
        subtitle,
        isBillCollapsible,
        isBillUncollapsed,
        onImpressionSavingsStamp,
    });

    const cartFooterHeight = document.documentElement.style.getPropertyValue(STYLE_SHEET_VAR.cartFooter);

    return (
        <ElementObserver
            options={{
                rootMargin: !isEmpty(cartFooterHeight) ? `0px 0px -${cartFooterHeight} 0px` : "0px 0px 0px 0px",
            }}
            onViewEnter={onBillEnter}
        >
            <div data-testid={SAVINGS_STAMP_TEST_IDS.SAVINGS_STAMP_CONTAINER}>
                {showLottie && (
                    <SavingsStampLottieContainer data-testid={SAVINGS_STAMP_TEST_IDS.SAVINGS_STAMP_CONTENT}>
                        <LottieAnimation
                            animationData={cloneDeep(lottieData)}
                            loop={false}
                            autoplay={true}
                            backwardSpeed={1}
                            forwardSpeed={1}
                            playIfVisible={false}
                            visible={true}
                            playLottie={true}
                        />
                    </SavingsStampLottieContainer>
                )}
            </div>
        </ElementObserver>
    );
}

export default memo(SavingsStamp);
